import { RealTimeAction } from '@/_core/fluxstore/types';
import { Release, StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';
import { useSendCommandAsync } from '@/_core/cqrs/use';
import { createCreateReleaseCommand } from '../../../api/commands/factory/createReleaseCommands';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SaveNewRelease extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'SaveNewRelease';

    public _savedRelease: Release = null;

    public constructor(public id: string, public name: string, public order: number) {
        super(SaveNewRelease.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SaveNewRelease): Promise<boolean> => {
    await useSendCommandAsync(action, {
        createCommand: async () => await createCreateReleaseCommand(action),
    });

    if (!action.isDispatchedByRealTimeCallback) {
        action._savedRelease = state.releases.find((x) => x.id === action.id);
    }

    return true;
};

const reducer = (state: StorymapState, action: SaveNewRelease): void => {
    if (action.isDispatchedByRealTimeCallback) {
        state.releases.filter((x) => x.order >= action._savedRelease.order && x.id != null).forEach((x) => x.order++);

        state.releases.push(action._savedRelease);
    }

    const release = state.releases.find((x) => x.id === action.id);

    release.name = action.name;
    release.isNew = false;
};

//@ts-ignore
registerMiddleware(SaveNewRelease.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SaveNewRelease.ACTION_TYPE, reducer);
